var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        title: _vm.$translate("Ceres::Template.singleItemWishList")
      }
    },
    [
      _c(
        "svg",
        {
          staticClass: "header-controls__icon",
          attrs: { width: "19", height: "16" }
        },
        [
          _c("use", {
            attrs: {
              "xlink:href": "#svg_wishlist",
              "xmlns:xlink": "http://www.w3.org/1999/xlink"
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.wishListCount > 0
        ? _c("span", { staticClass: "header-controls__item-badge" }, [
            _vm._v(_vm._s(_vm.wishListCount))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }